import { isAuthorized } from 'utils/Auth'
import { debounce } from 'lodash'
import { createReducer } from '../../utils'

export const CHANGE_TAB = 'sherrinford/ZotapayInvoices/list/CHANGE_TAB'

export const GET_INVOICES_REQUEST =
  'sherrinford/ZotapayInvoices/list/GET_INVOICES_REQUEST'
export const GET_INVOICES_SUCCESS =
  'sherrinford/ZotapayInvoices/list/GET_INVOICES_SUCCESS'
export const GET_INVOICES_ERROR = 'sherrinford/ZotapayInvoices/list/GET_INVOICES_ERROR'

export const SET_END_DATE_CHECKER =
  'sherrinford/ZotapayInvoices/list/SET_END_DATE_CHECKER'
export const UPDATE_QS = 'sherrinford/ZotapayInvoices/list/UPDATE_QS'
export const SET_START_DATE = 'sherrinford/ZotapayInvoices/list/SET_START_DATE'
export const SET_END_DATE = 'sherrinford/ZotapayInvoices/list/SET_END_DATE'

export const SET_SORT = 'sherrinford/ZotapayInvoices/list/SET_SORT'
export const OPEN_FILTER = 'sherrinford/ZotapayInvoices/list/OPEN_FILTER'
export const CHECKED_FILTER = 'sherrinford/ZotapayInvoices/list/CHECKED_FILTER'
export const SET_SEARCH_BY = 'sherrinford/ZotapayInvoices/list/SET_SEARCH_BY'
export const SET_SEARCH_KEY_WORDS =
  'sherrinford/ZotapayInvoices/list/SET_SEARCH_KEY_WORDS'

const initialState = {
  debouncing: debounce(cb => cb(), 1000),
  searchBy: 'invoiceNumber',
  searchKeyWords: '',
  startDate: null,
  endDate: null,
  sort: 'ASC',
  isEndDateCheck: false,
  openFilterStatus: false,
  openFilterType: false,
  openFilterCountry: false,
  openFilterPaymentMethod: false,
  checkedFilterStatus: [],
  checkedFilterType: [],
  checkedFilterCountry: [],
  checkedFilterPaymentMethod: [],
  tab: 0,
  invoices: {},
  isLoading: false,
  invoiceStatus: {
    pending: {
      status: 1,
      label: 'Pending',
    },
    paid: {
      status: 2,
      label: 'Paid',
    },
    failed: {
      status: 3,
      label: 'Failed',
    },
  },
  qs: {
    sort: 'createdAt DESC',
    limit: 10,
    skip: 0,
    where: {
      status: {
        '>': 0,
      },
    },
  },
}

export default createReducer(initialState, {
  [SET_SEARCH_KEY_WORDS]: (state, value) => ({
    ...state,
    searchKeyWords: value,
  }),
  [SET_SEARCH_BY]: (state, value) => ({
    ...state,
    searchBy: value,
  }),
  [CHECKED_FILTER]: (state, payload) => {
    // -- Condition for checking which reducer that should returned depends on payload.filter -- //
    switch (payload.filter) {
      case 'status':
        if (payload.isChecked) {
          return {
            ...state,
            checkedFilterStatus: [...state.checkedFilterStatus, payload.value],
          }
        }
        return {
          ...state,
          checkedFilterStatus: state.checkedFilterStatus.filter(
            value => value !== payload.value
          ),
        }
      case 'type':
        if (payload.isChecked) {
          return {
            ...state,
            checkedFilterType: [...state.checkedFilterType, payload.value],
          }
        }
        return {
          ...state,
          checkedFilterType: state.checkedFilterType.filter(
            value => value !== payload.value
          ),
        }
      case 'payment':
        if (payload.isChecked) {
          return {
            ...state,
            checkedFilterPaymentMethod: [
              ...state.checkedFilterPaymentMethod,
              payload.value,
            ],
          }
        }
        return {
          ...state,
          checkedFilterPaymentMethod: state.checkedFilterPaymentMethod.filter(
            value => value !== payload.value
          ),
        }
      default:
        if (payload.isChecked) {
          return {
            ...state,
            checkedFilterCountry: [...state.checkedFilterCountry, payload.value],
          }
        }
        return {
          ...state,
          checkedFilterCountry: state.checkedFilterCountry.filter(
            value => value !== payload.value
          ),
        }
    }
  },
  [OPEN_FILTER]: (state, payload) => {
    // -- Condition for checking wich reducer that should returned depends on payload.filter -- //
    switch (payload.filter) {
      case 'status':
        return {
          ...state,
          openFilterStatus: payload.value,
        }
      case 'type':
        return {
          ...state,
          openFilterType: payload.value,
        }
      case 'country':
        return {
          ...state,
          openFilterCountry: payload.value,
        }
      case 'payment':
        return {
          ...state,
          openFilterPaymentMethod: payload.value,
        }
      default:
        return {
          ...state,
          openFilterStatus: payload.value,
          openFilterType: payload.value,
          openFilterCountry: payload.value,
          openFilterPaymentMethod: payload.value,
        }
    }
  },
  [SET_SORT]: (state, value) => ({
    ...state,
    sort: value,
  }),
  [SET_END_DATE_CHECKER]: (state, value) => ({
    ...state,
    isEndDateCheck: value,
  }),
  [UPDATE_QS]: (state, newQs) => ({
    ...state,
    qs: newQs,
  }),
  [SET_START_DATE]: (state, date) => ({
    ...state,
    startDate: date,
  }),
  [SET_END_DATE]: (state, date) => ({
    ...state,
    endDate: date,
  }),
  [CHANGE_TAB]: (state, value) => ({
    ...state,
    tab: value,
    checkedFilterStatus: [],
    checkedFilterType: [],
    checkedFilterPaymentMethod: [],
  }),
  [GET_INVOICES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    openFilterStatus: false,
    openFilterType: false,
    openFilterCountry: false,
    openFilterPaymentMethod: false,
  }),
  [GET_INVOICES_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    invoices: data,
  }),
  [GET_INVOICES_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const setSearchKeyWords = value => ({
  type: [SET_SEARCH_KEY_WORDS],
  payload: value,
})

export const setSearchBy = value => ({
  type: [SET_SEARCH_BY],
  payload: value,
})

export const setCheckedFilterStatus = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const removeCheckedFilterStatus = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const setCheckedFilterType = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const removeCheckedFilterType = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const setCheckedFilterCurrency = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const removeCheckedFilterCurrency = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const setCheckedFilterCountry = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const removeCheckedFilterCountry = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const setCheckedFilterPaymentMethod = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const removeCheckedFilterPaymentMethod = payload => ({
  type: [CHECKED_FILTER],
  payload,
})

export const openFilter = (value, filter) => ({
  type: [OPEN_FILTER],
  payload: {
    value,
    filter,
  },
})

export const setSort = value => ({
  type: [SET_SORT],
  payload: value,
})

export const setStartDate = date => ({
  type: [SET_START_DATE],
  payload: date,
})

export const setEndDate = date => ({
  type: [SET_END_DATE],
  payload: date,
})

export const updateQs = newQs => ({
  type: [UPDATE_QS],
  payload: newQs,
})

export const setEndDateChecker = value => ({
  type: [SET_END_DATE_CHECKER],
  payload: value,
})

export const getInvoices = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_INVOICES_REQUEST, GET_INVOICES_SUCCESS, GET_INVOICES_ERROR],
    shuttle: {
      method: 'GET',
      path: '/invoice',
      authorization: `${token}`,
      qs,
      universeHost: true,
    },
    nextAction: res => cb(res),
  }
}

export const changeTab = value => ({
  type: [CHANGE_TAB],
  payload: value,
})
